function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_228",
  "data-name": "Rectangle 228",
  width: 26,
  height: 26,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Exclusion_24",
  "data-name": "Exclusion 24",
  d: "M5405.059-854h0v-8.979l10.679-2.074.045,8.991L5405.06-854Zm-1.051-.05h0l-6.96-2.089v-9.014l6.961,2.128v8.973Zm.553-9.9h0l-5.873-1.8,9.49-1.843.084,0,5.9,1.771-9.6,1.865Zm5.2-2.83a.534.534,0,0,0-.1.009l-5.858,1.136a.521.521,0,0,0-.335.222.522.522,0,0,0-.08.393.524.524,0,0,0,.514.425.491.491,0,0,0,.1-.01l5.858-1.138a.525.525,0,0,0,.415-.616A.523.523,0,0,0,5409.76-866.783Zm-12.716.149h0l-.043-7.212L5407.723-876v7.293l-10.678,2.073Z",
  transform: "translate(-5392 878)",
  fill: "#fff"
});

function SvgIconBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_box",
    "data-name": "icon - box",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon-box.59bb847a.svg";
export { ForwardRef as ReactComponent };